import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

// ponytail: temporary swap — flip to true to bring the ElevenLabs voice orb back.
const USE_ELEVENLABS = false;

const AGENT_ID = "agent_2401kqtzrq59fdtakphq07w8wtzc";
const SCRIPT_SRC = "https://unpkg.com/@elevenlabs/convai-widget-embed";
const ELEMENT_ID = "heallexa-elevenlabs-convai";

const LC_LOADER = "https://widgets.leadconnectorhq.com/loader.js";
const LC_RESOURCES = "https://widgets.leadconnectorhq.com/chat-widget/loader.js";
const LC_WIDGET_ID = "6a713c8d26a343b92b94ef7c";

export function ElevenLabsWidget() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isDashboard = pathname.startsWith("/dashboard");

  useEffect(() => {
    if (isDashboard) {
      const existing = document.getElementById(ELEMENT_ID);
      if (existing) existing.remove();
      return;
    }
    if (USE_ELEVENLABS) {
      if (!document.getElementById(ELEMENT_ID)) {
        const el = document.createElement("elevenlabs-convai");
        el.id = ELEMENT_ID;
        el.setAttribute("agent-id", AGENT_ID);
        // Smallest resting state — orb + call icon, no "Book 24/7" bar. Clicking
        // it still expands to the full conversation UI.
        el.setAttribute("variant", "tiny");
        document.body.appendChild(el);
      }
      if (!document.querySelector(`script[data-elevenlabs-convai]`)) {
        const s = document.createElement("script");
        s.src = SCRIPT_SRC;
        s.async = true;
        s.type = "text/javascript";
        s.setAttribute("data-elevenlabs-convai", "true");
        document.body.appendChild(s);
      }
      return;
    }
    if (!document.querySelector("script[data-leadconnector-chat]")) {
      const s = document.createElement("script");
      s.src = LC_LOADER;
      s.async = true;
      s.setAttribute("data-resources-url", LC_RESOURCES);
      s.setAttribute("data-widget-id", LC_WIDGET_ID);
      s.setAttribute("data-source", "WEB_USER");
      s.setAttribute("data-leadconnector-chat", "true");
      document.body.appendChild(s);
    }
  }, [isDashboard]);

  return null;
}
